import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=2d67b16e&scoped=true&"
import script from "./overview.ts?vue&type=script&lang=ts&"
export * from "./overview.ts?vue&type=script&lang=ts&"
import style0 from "./overview.scss?vue&type=style&index=0&id=2d67b16e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d67b16e",
  null
  
)

component.options.__file = "overview.vue"
export default component.exports